function n(n){return function(t){return n(t)}}export{n as default};
//# sourceMappingURL=_baseUnary.js.map
